<template>
    <div class="btn-group">
        <el-tooltip content="Export Messages">
            <button v-if="canExport" class="btn btn-secondary btn-sm" @click="exportHandler">
                <i class="fas fa-download"></i>
            </button>
        </el-tooltip>
        <el-tooltip content="Delete">
            <button v-if="canDelete" class="btn btn-danger btn-sm" @click="confirmDeleting">
                <i class="fas fa-trash-alt"></i>
            </button>
        </el-tooltip>
    </div>
</template>

<script>
  export default {
    props: [
      'row'
    ],

    computed: {
      /**
       * @return {boolean}
       */
      canDelete() {
        return this.row.canDelete;
      },

      /**
       * @return {string}
       */
      deleteUrl() {
        return this.row.deleteUrl;
      },

      /**
       * @return {boolean}
       */
      canExport() {
        return this.row.canExport;
      },

      /**
       * @return {string}
       */
      exportUrl() {
        return this.row.exportUrl;
      },


    },

    methods: {
      /**
       * @event delete
       */
      confirmDeleting() {
        this.$confirm('Are you sure you want to delete this item?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        })
          .then(() => this.$emit('delete', {row: this.row, url: this.deleteUrl}))
          .catch(() => {
          });
      },

      /**
       * @event export
       */
      exportHandler() {
        this.$emit('export', {row: this.row, url: this.exportUrl});
      },


    },
  }
</script>
